import { useCallback, useState } from 'react'

export function useReviewModal(initialOpen = false) {
  const [open, setOpen] = useState(initialOpen)
  const openModal = useCallback(() => setOpen(true), [])
  const closeModal = useCallback(() => setOpen(false), [])
  return { open, openModal, closeModal }
}
